/** @file facingStepsOf: the facing steps in force while a clip plays (17.3). */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** `clip.facingSteps ?? puppet.facing.steps` (no clip -> the puppet's steps). */
export function facingStepsOf(puppet: Pick<Puppet, 'facing'>, clip: Pick<Clip, 'facingSteps'> | null): number | 'free' {
  return clip?.facingSteps ?? puppet.facing.steps;
}
